import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_desktop_view = _resolveComponent("desktop-view")!
  const _component_mobile_view = _resolveComponent("mobile-view")!

  return (!_ctx.gl.isMobile)
    ? (_openBlock(), _createBlock(_component_desktop_view, { key: 0 }))
    : (_openBlock(), _createBlock(_component_mobile_view, { key: 1 }))
}